module.exports = __webpack_public_path__ + "img/social_in_white.46cf7277.png";